import { jsx } from '@amazon/vinyl-tsx'
import { getAuth } from '@/auth/authRef'
import { Icon } from '@/components/Icon'
import { Link } from '@/components/Link'
import { getString } from '@/auth/i18n/bundle.generated'

/**
 * Signed-out landing page. Rendered by the router for gated routes (home,
 * chat) when the current session isn't signed in. Presents a hero mark, a
 * short benefits list, and a single primary CTA that kicks off the auth
 * handshake.
 */
export function SignInWall() {
    return (
        <div className="signInWall" aria-label={getString('dmusic_sign_in_wall_aria_label')}>
            <div className="signInWallHero" aria-hidden="true">
                <Icon icon="amazonMusic" className="signInWallHeroIcon" />
            </div>
            <h1 className="signInWallTitle">{getString('dmusic_sign_in_wall_title')}</h1>
            <p className="signInWallSubtitle">{getString('dmusic_sign_in_wall_subtitle')}</p>
            <ul className="signInWallBenefits">
                <li className="signInWallBenefit">
                    {getString('dmusic_sign_in_wall_benefit_recommendations')}
                </li>
                <li className="signInWallBenefit">
                    {getString('dmusic_sign_in_wall_benefit_library')}
                </li>
                <li className="signInWallBenefit">
                    {getString('dmusic_sign_in_wall_benefit_chat')}
                </li>
            </ul>
            <button className="textButton signInWallCta" onclick={() => getAuth().signIn()}>
                {getString('dmusic_sign_in_wall_cta')}
            </button>
            {/* Anonymous listeners without an Amazon account can't sign in to an
                existing plan — offer a path to the subscription plans instead
                (mirrors hornet's unauthorized "Show plans" upgrade link). */}
            <Link className="textLink signInWallShowPlans" href="/subscription">
                {getString('dmusic_sign_in_wall_show_plans')}
            </Link>
        </div>
    )
}
